import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation Case($activityId: String!, $status: String!){
  UpdateCase(activityId: $activityId, status: $status){
    id
  }
}`;

function updateCase(activityId, status) {
  return apollo.client.mutate({
    mutation,
    variables: {
      activityId,
      status: status.toUpperCase(),
    },
  }).then((res) => (res.data.UpdateCase));
}

export default updateCase;
